import { getCurriculum } from '../../content/curriculum';

export const selectAvailableCharacters = levelIndex => (
  [getCurriculum().levels[levelIndex].character]
);

export const selectAvailableQuestionSetIds = () => (
  []
);

export const getQuestionSet = levelIndex => (
  getCurriculum().levels[levelIndex]
);

export const getBookIds = levelIndex => (
  getQuestionSet(levelIndex).books
);

const getBook = bookId => (
  getCurriculum().books.find(bookObject => bookObject.id === bookId)
);

export const getBookColor = bookId => (
  getBook(bookId).color
);

export const getBookText = bookId => (
  getBook(bookId).text
);

export const getBookTitle = bookId => (
  getBook(bookId).title
);

export const getCharacter = levelIndex => (
  getQuestionSet(levelIndex).character
);

const getQuestion = (levelIndex, questionIndex) => (
  getQuestionSet(levelIndex).questions[questionIndex]
);

export const getCorrectResponseId = (levelIndex, questionIndex) => (
  getQuestion(levelIndex, questionIndex).correctResponse
);

export const getQuestionId = (levelIndex, questionIndex, idType = 'id') => (
  getQuestion(levelIndex, questionIndex)[idType]
);

export const getQuestionText = (levelIndex, questionIndex) => (
  getQuestion(levelIndex, questionIndex).text
);

/**
 * Return the next unplayed question set in the requested level (if any) or a random set to replay if all seen already
 * @param {integer} levelIndex - which level in curriculum (from 0 to 3)
 * @param {Array.<Array.<integer>>} completedQuestionSetIds - which set ids have already been played
 * @return {string}
 * @example getNextQuestionSetId(0, [['pigs'], [], [], []]) => 'presidents'
 */
export const getNextQuestionSetId = () => (
  []
);

export const isLastQuestion = (levelIndex, questionIndex) => (
  questionIndex + 1 >= getQuestionSet(levelIndex).questions.length
);

export const getTextForCharacterIntroScreen = (levelIndex, screenIndex) => (
  getQuestionSet(levelIndex).intro.screens[screenIndex].text
);

export const getOptionsForCharacterIntroScreen = (levelIndex, screenIndex) => (
  getQuestionSet(levelIndex).intro.screens[screenIndex].options
);

export const getCharacterIntroScreenCount = levelIndex => (
  getQuestionSet(levelIndex).intro.screens.length
);

// Possible actions for SELECT event reporting
export const getPossibleAnswers = (bookIds) => {
  const possibleActions = bookIds;
  possibleActions[2] = 'BOTH';
  return possibleActions;
};

export const getWinningColorForLevel = (levelId) => {
  const questionSet = getQuestionSet(levelId);
  // answerCounts will be counter of how many times each book in questionSet.books
  // is the correct answer for a question
  const answerCounts = [0, 0];
  for (let i = 0; i < questionSet.questions.length; i++) {
    if (questionSet.questions[i].correctResponse === questionSet.books[0]) {
      answerCounts[0]++;
    } else if (questionSet.questions[i].correctResponse === questionSet.books[1]) {
      answerCounts[1]++;
    }
  }
  if (answerCounts[0] > answerCounts[1]) {
    return getBookColor(questionSet.books[0]);
  }
  return getBookColor(questionSet.books[1]);
};
